//
import Model from '@/models/Model'
import AAvailableBranchOfficesModel from "@/models/Actions/AAvailableBranchOffices"
import AChangeBranchOfficeModel from "@/models/Actions/AChangeBranchOffice"

/**
 *
 */
export default class HrEmployee extends Model {

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    available_branch_offices() {
        return this.hasMany(AAvailableBranchOfficesModel)
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    change_branch_office() {
        return this.hasMany(AChangeBranchOfficeModel)
    }

    //
    static includes = [
        'active_contract',
        'active_contract.hr_contract_type',
        'active_contract.hr_contract_period',
        'active_contract.hr_contract_asset_discount.hr_asset_discount.hr_asset_discount_type',
        'all_contract',
        'hr_family_burdens',
        'hr_isapre_plans.hr_isapre_type',
        'hr_isapre_plan_active.hr_isapre_type',
        'hr_employee_apv.hr_previred_apv',
        'hr_employee_apv.hr_previred_apv_payment_type',
        'hr_employee_ips.hr_previred_ips',
        'hr_previred_nationality',
        'hr_previred_employee_type',
        'hr_prevision',
    ]

    /**
     *
     */
    get can_active_contract() {
        return this.has_contracts && !this.active_contract
    }

    /**
     *
     */
    get full_name() {
        return [this.names, this.last_name1, this.last_name2].join(' ')
    }

    /**
     *
     */
    get has_contracts() {
        return this.all_contract.length > 0
    }

    /**
     *
     */
    get hr_prevision_name() {
        return String(this.hr_prevision.name)
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get g_branch_office_name() {
        return this.getProperty('g_branch_office.name', '-')
    }

    /**
     *
     */
    resource() {
        return 'hr_employee'
    }

    /**
     * Returns a change branch office representation of the object.
     *
     * @return     {<type>}  Change branch office representation of the object.
     */
    toChangeBranchOffice() {
        return this.clean([
            'g_branch_office_id'
        ])
    }
}
